import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { ACTION_PLAN_STATUS } from '../../common/utils'
import dateService from 'live/services/date'
import { ParamsContext } from '../qualityMonitoring'
import { getProduct } from '../../common/apis'
import pepsicoLogo from '../../assets/pepsico.png'
interface IProps {
    lastAnalysisTimestamp: number
    lastResult: number
    actionPlansStatus: boolean[]
}

export function SensorialHeading({ lastAnalysisTimestamp, lastResult, actionPlansStatus }: IProps): JSX.Element {
    const [totalPlans, setTotalPlans] = useState(0)
    const [donePlans, setDonePlans] = useState(0)
    const urlParams = useContext(ParamsContext)
    const [imageId, setImageId] = useState('')

    useEffect(() => {
        const urlParamsArray = urlParams.split('/')
        const productName = urlParamsArray[urlParamsArray.length - 1]

        if (productName) {
            getProduct(productName)
                .then(product => {
                    const { productImageId } = product
                    if (productImageId && productImageId !== 'defaultImage') setImageId(productImageId)
                })
                .catch(() => {
                    setImageId(undefined)
                })
        }
    }, [urlParams])

    const logoSrc = imageId ? `/services/plugin-upload/download/${imageId}` : pepsicoLogo

    useEffect(() => {
        setTotalPlans(actionPlansStatus.length)
        setDonePlans(actionPlansStatus.filter(status => status).length)
    }, [actionPlansStatus])

    return (
        <StyledSensorialHeading className={`sensorialHeading`}>
            <div className="sensorialHeading--logo">
                <img src={logoSrc} alt="logo" />
            </div>
            <h1 className="sensorialHeading--title">{i18n('Quality Control')}</h1>
            <div className="sensorialHeading--lastAnalysis">
                <div className="sensorialHeading--lastAnalysis__title">{i18n('Last Analysis')}</div>
                <div className="sensorialHeading--lastAnalysis__value">
                    <strong>
                        {lastAnalysisTimestamp
                            ? dateService.fromNow(lastAnalysisTimestamp)
                            : 'No analysis in this timestamp'}
                    </strong>
                    {/* h<strong>{lastAnalysisMin}</strong>min <span>{i18n('ago')}</span> */}
                </div>
            </div>
            <div className="sensorialHeading--lastResult">
                <div className="sensorialHeading--lastResult__title">{i18n('Last Result')}</div>
                <div className="sensorialHeading--lastResult__value">
                    <strong>{lastResult || 0}</strong>
                    <span>%</span>
                </div>
            </div>
            <div className="sensorialHeading--actionPlans">
                <div className="sensorialHeading--actionPlans__title">{i18n('Action Plans')}</div>
                <div className="sensorialHeading--actionPlans__value">
                    <strong>{donePlans}</strong>{' '}
                    <span>
                        / {totalPlans} {i18n(ACTION_PLAN_STATUS.DONE)}
                    </span>
                </div>
            </div>
        </StyledSensorialHeading>
    )
}

const StyledSensorialHeading = styled.div`
    width: 100%;
    background: ${({ theme }) => theme['gray-1000']};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 15px 24px;
    height: 130px;
    .sensorialHeading {
        &--logo {
            margin-right: 16px;
            img {
                max-width: 100px;
                max-height: 100px;
            }
        }
        &--title {
            color: ${({ theme }) => theme['gray-0']};
            font-family: ${({ theme }) => theme['font-bold']};
            flex-grow: 1;
            font-size: 25px;
            line-height: 25px;
        }
        &--lastAnalysis,
        &--lastResult {
            padding-right: 24px;
            margin-right: 24px;
            border-right: 1px solid ${({ theme }) => theme['gray-0']};
        }
        &--lastAnalysis,
        &--lastResult,
        &--actionPlans {
            &__title {
                color: ${({ theme }) => theme['gray-0']};
                font-family: ${({ theme }) => theme['font-semibold']};
                text-transform: uppercase;
                font-size: 18px;
                margin-bottom: 15px;
            }
            &__value {
                color: ${({ theme }) => theme['green-700']};
                font-size: 17px;
                strong {
                    font-size: 24px;
                }
                span {
                    font-size: 17px;
                    color: ${({ theme }) => theme['gray-0']};
                }
            }
        }
    }
`
